import { mountApplications } from '~/pages/shared/wikis/show';

mountApplications();
